import { Flame, Snowflake } from 'lucide-react';
import { useSparks } from '../contexts/SparksContext';

/** Nav chips: daily streak (flame) and held freezes (blue snowflake). Celebration cards live in Sparks/CelebrationQueue. */
function StreakBadge() {
  const { dailyStreak, streakFreezes } = useSparks();

  // Hide badge until student earns their first streak day
  if (!dailyStreak || dailyStreak < 1) return null;

  return (
    <div
      title={`${dailyStreak}-day streak!${streakFreezes ? ` ${streakFreezes} streak ${streakFreezes === 1 ? 'freeze' : 'freezes'}` : ''}`}
      className="flex items-center gap-1.5 select-none cursor-default"
      data-testid="streak-badge"
    >
      <div className="flex items-center gap-1 px-2 py-1 rounded-full text-white text-sm font-semibold bg-orange-500/90">
        <Flame className="w-4 h-4 text-yellow-200 shrink-0" aria-hidden="true" />
        <span>{dailyStreak}</span>
      </div>
      {streakFreezes > 0 && (
        <div
          className="flex items-center gap-1 px-2 py-1 rounded-full text-sm font-semibold bg-sky-500/90 text-white"
          aria-label={`${streakFreezes} ${streakFreezes === 1 ? 'freeze' : 'freezes'}`}
          data-testid="streak-freeze"
        >
          <Snowflake className="w-4 h-4 text-sky-100 shrink-0" aria-hidden="true" />
          <span>{streakFreezes}</span>
        </div>
      )}
    </div>
  );
}

export default StreakBadge;
